export default function() {
    this.loadPosts()
}
